export default __webpack_public_path__ + "static/media/dog.c703c40c.jpg";